export default "__VITE_ASSET__6w9S4Caz__"